import { Modal } from 'antd'
import { markdownToTxt } from 'components/MarkdownToText';
import { IReadingAssessmentResponse } from 'components/useReadingAssessmentResponse'
import { useEffect, useState } from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import { diffChars } from 'diff'

type Props = {
    onClose: () => void
    readingAssessmentResponse: IReadingAssessmentResponse
}



export default function ResponseModal({ onClose, readingAssessmentResponse }: Props) {
    const [userTranscript, setUserTranscript] = useState("")
    const [originalParagraph, setOriginalParagraph] = useState("")
    const [score, setScore] = useState<string>()

    useEffect(() => {
        if (readingAssessmentResponse) {
            let trimmed = readingAssessmentResponse.transcript.split("\n").map(l => {
                return l.replace(/^\[[\d\.]+->[\d\.]+\]/, "").trim()
            }).filter(l => l.trim()).join(" ")
            setUserTranscript(trimmed)
            let original = markdownToTxt(readingAssessmentResponse.reading_assessment.paragraph)
                .split("\n").filter(l => l.trim()).join(" ")
            setOriginalParagraph(original)
            // console.log(original)
            // console.log(trimmed)
            let diffArray = diffChars(original, trimmed, { ignoreCase: true });
            diffArray = diffArray.filter(v => ![".", ":", ",", "'", "!", "?"].includes(v.value))
            let totalDiff = 0, total = 0
            diffArray.forEach(diff => {
                total += diff.count
                if (diff.added || diff.removed) {
                    totalDiff += diff.count
                }
            });
            let exactScore = (1 - ((totalDiff) / total)) * 100
            console.log(diffArray, total, totalDiff, exactScore)
            setScore(exactScore.toFixed(2))
        }
    }, [readingAssessmentResponse])

    return (
        <Modal
            open
            onCancel={onClose}
            footer={null}
            width={"80vw"}
        >
            <div className="d-flex flex-column">
                <h3 className='is-size-3 mb-5'>
                    <strong>
                        {`${readingAssessmentResponse.user.firstName}'s response`}
                    </strong>
                </h3>
                <audio controls className='mx-auto mb-5'>
                    <source src={readingAssessmentResponse.audio?.url} type="audio/mpeg" />
                    Your browser does not support the audio tag.
                </audio>
                <strong className='mb-3 between'>
                    Original Paragraph vs Transcript
                    <h5 className='is-size-5 has-text-weight-bold'>Match {score} %</h5>
                </strong>
                <ReactDiffViewer
                    compareMethod={DiffMethod.WORDS}
                    oldValue={originalParagraph}
                    newValue={userTranscript}
                    splitView={true}
                    hideLineNumbers
                    hideMarkers
                />
                {/* <code className='py-3 px-6'>
                    {readingAssessmentResponse.transcript?.split("\n").map(p => <div className='my-3'>{p}</div>)}
                </code> */}
            </div>
        </Modal>
    )
}